import getLang from 'I18n/utils/getLang';
import { GET_SUGGESTION_SECTIONS_QUERY as PUBLIC_GET_SUGGESTION_SECTIONS_QUERY } from '../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationPublicRpc.dfc.new';
import { GET_SUGGESTION_SECTIONS_QUERY } from '../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationRpc.dfc.new';
import { usePersonalizationQuery } from './usePersonalizationQuery';
export function useGetSuggestionSections() {
  return usePersonalizationQuery({
    public: PUBLIC_GET_SUGGESTION_SECTIONS_QUERY,
    app: GET_SUGGESTION_SECTIONS_QUERY,
    options: {
      variables: {
        maximumSections: 10,
        language: getLang(),
        minimumSectionCardCount: 4,
        maximumSectionCardCount: 10
      }
    }
  });
}